export const scrollToDivElement = (elementId: string) => {
  const element = document.getElementById(elementId);

  element?.scrollIntoView({ behavior: "smooth" });
};
